import { render, staticRenderFns } from "./DownloadsSection.vue?vue&type=template&id=d75bc760"
import script from "./DownloadsSection.vue?vue&type=script&lang=js"
export * from "./DownloadsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports